<div class="nav-bar">
  <div class="nav-bar__container">
    <ng-container *ngFor="let menu of menus; let index = index">
      <button
        class="nav-button htv-selectable {{ index === selectedIndex ? 'htv-focus' : '' }}"
        (click)="onClick(menu)">
        <img class="nav-button__icon" [src]="menu.mediaSrc" />
        <span class="nav-button__label">{{ menu.label }}</span>
      </button>
    </ng-container>
  </div>
</div>
